"use client";
import Link from "next/link";
import { Button } from "@/app/components/shadcn/button";
import { SectionItem } from "@/app/lib/features/home/home.types";
import FallbackImage from "@/app/components/elements/FallbackImage";
import { trackCategoryClick } from "@/app/lib/tracking/interactions";

interface TrendCategoryCardProps {
  item: SectionItem;
  priority?: boolean;
}

const TrendCategoryCard = ({
  item,
  priority = false,
}: TrendCategoryCardProps) => {
  const itemTitle = item.title || "Kategori";
  const itemSlug = item.slug || "#";

  return (
    <Link
      href={`/${itemSlug}`}
      className="rounded-lg overflow-hidden block aspect-262/294 group relative bg-linear-to-br from-gray-50 to-gray-100"
      onClick={() => { if (item.id) trackCategoryClick(item.id); }}
    >
      <FallbackImage
        src={item.image}
        alt={itemTitle}
        fill
        className="object-cover group-hover:scale-105 transition-all duration-300 ease-in-out"
        fallbackClassName="object-contain scale-75 opacity-80"
        sizes="(max-width: 640px) 50vw, (max-width: 1024px) 50vw, 25vw"
        quality={70}
        {...(priority ? { priority: true } : { loading: "lazy" as const })}
      />
      <div className="absolute bottom-1 sm:bottom-2 lg:bottom-3 left-1/2 -translate-x-1/2 z-10">
        <Button
          variant="outline"
          size="xs"
          className="h-6 px-2 sm:h-7 sm:px-2 lg:h-8 lg:px-3 text-xs sm:text-xs lg:text-sm bg-white/90 backdrop-blur-sm"
        >
          {item.icon && <span className="mr-1">{item.icon}</span>}
          {itemTitle}
        </Button>
      </div>
    </Link>
  );
};

export default TrendCategoryCard;
